export const WarehouseExpectedDeliveryDetailedItem = (
	json: IWarehouseExpectedDeliveryDetailedItem,
): IWarehouseExpectedDeliveryDetailedItemModel => {
	const {
		raw_material_id,
		supplier_product_name,
		internal_name,
		expected_quantity,
		received_quantity,
		receiving_status,
		quantity_status,
		delivery_receipt_id,
		is_editable,
		expiry_date,
		...rest
	} = json

	return {
		...rest,
		rawMaterialID: raw_material_id,
		supplierProductName: supplier_product_name,
		internalName: internal_name,
		expectedQuantity: expected_quantity,
		receivedQuantity: received_quantity,
		receivingStatus: receiving_status,
		quantityStatus: quantity_status,
		deliveryReceiptID: delivery_receipt_id,
		isEditable: is_editable,
		expiryDate: expiry_date ? new Date(expiry_date) : null,
	}
}

export const WarehouseExpectedDeliveryPurchaseOrder = (
	json: IWarehouseExpectedDeliveryPurchaseOrder,
): IWarehouseExpectedDeliveryPurchaseOrderModel => {
	const { purchase_order_id, purchase_order_number, ...rest } = json

	return {
		...rest,
		purchaseOrderID: purchase_order_id,
		purchaseOrderNumber: purchase_order_number,
	}
}

export const WarehouseExpectedDeliveryDetailedDocument = (
	json: IWarehouseExpectedDeliveryDetailedDocument,
): IWarehouseExpectedDeliveryDetailedDocumentModel => {
	const { mime_type, original_filename, size_bytes, uploaded_at, uploaded_by, ...rest } = json

	return {
		...rest,
		mimeType: mime_type,
		originalFilename: original_filename,
		sizeBytes: size_bytes,
		uploadedAt: new Date(uploaded_at),
		uploadedBy: uploaded_by,
	}
}

export const WarehouseExpectedDeliveryDetailedDelivery = (
	json: IWarehouseExpectedDeliveryDetailedDelivery,
): IWarehouseExpectedDeliveryDetailedDeliveryModel => {
	const { started_at, delivery_document_number, documents, ...rest } = json

	return {
		...rest,
		startedAt: new Date(started_at),
		deliveryDocumentNumber: delivery_document_number ?? null,
		documents: (documents ?? []).map(WarehouseExpectedDeliveryDetailedDocument),
	}
}

export const WarehouseExpectedDeliveryDetailedComplaint = (
	json: IWarehouseExpectedDeliveryDetailedComplaint,
): IWarehouseExpectedDeliveryDetailedComplaintModel => {
	const { complaint_reason, delivery_receipt_id, expected_delivery_item_id, raw_material_id, ...rest } = json

	return {
		...rest,
		complaintReason: complaint_reason,
		deliveryReceiptID: delivery_receipt_id,
		expectedDeliveryItemID: expected_delivery_item_id,
		rawMaterialID: raw_material_id,
	}
}

export const WarehouseExpectedDeliveryDetailed = (
	json: IWarehouseExpectedDeliveryDetailed,
): IWarehouseExpectedDeliveryDetailedModel => {
	const {
		supplier_id,
		supplier_name,
		planned_delivery_date,
		progress,
		purchase_orders,
		items,
		deliveries,
		complaints,
		...rest
	} = json

	return {
		...rest,
		supplierID: supplier_id,
		supplierName: supplier_name,
		plannedDeliveryDate: new Date(planned_delivery_date),
		progress,
		purchaseOrders: (purchase_orders ?? []).map(WarehouseExpectedDeliveryPurchaseOrder),
		items: (items ?? []).map(WarehouseExpectedDeliveryDetailedItem),
		deliveries: (deliveries ?? []).map(WarehouseExpectedDeliveryDetailedDelivery),
		complaints: (complaints ?? []).map(WarehouseExpectedDeliveryDetailedComplaint),
	}
}
